import Model, { attr } from '@ember-data/model';

import type { DateRangeInterface, DSSetup, RecordData } from 'webapp-types';
import type { TeamSectionItemType } from 'webapp/enums/enums';

export default class TeamSectionItemRecord extends Model {
	@attr('number') position!: number;
	@attr('number') objectType!: TeamSectionItemType;
	@attr('number') objectId!: number | null;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	objectData!: RecordData.TeamSectionItem.ObjectData;
	@attr('number') sectionId!: number;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	dateRange!: DateRangeInterface.FormulaInterface;
	@attr('string') metricSetupKey!: string | null;
	@attr('number') metricSetupSpaceAccessId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	metricSetupDimensions!: string[];
	@attr('object') metricSetupFilters!: DSSetup.MetricSetupFiltersData | null;
}
